export enum AgeGroups {
  Adult = 'ADULT',
  Child = 'CHILD',
  Infant = 'INFANT',
}

export enum TitleVariant {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
}
